const A = "https://customer-assets-jt897jd0.emergentagent.net/job_property-manager-425/artifacts";

export const HERO_SLIDES = [
  {
    src: `${A}/twz5zrio_02d799eb-70de-4835-a7bf-f3a6921de38d.webp`,
    alt: "Oaks Urangan at dusk — lit pools and the ocean beyond, Hervey Bay",
    caption: "Paradisio · Oaks Urangan, Hervey Bay",
  },
  {
    src: `${A}/wo65qgt3_IMG_6648.webp`,
    alt: "Kirra Beach, Coolangatta, at golden hour",
    caption: "Casa d' Mar · absolute beachfront, Kirra",
  },
  {
    src: `${A}/75pngu8r_1bc420c0-2e81-4886-8072-b547f762582f.webp`,
    alt: "Resort pool and palms at Urangan, Hervey Bay",
    caption: "Pools heated year-round · Urangan",
  },
  {
    src: `${A}/bbhyin5f_IMG_6644.webp`,
    alt: "Living room ocean outlook at Casa d' Mar, Kirra",
    caption: "270° ocean outlook · Casa d' Mar",
  },
];

export const WHALE_IMAGE =
  "https://images.unsplash.com/photo-1568430462989-44163eb1752f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxodW1wYmFjayUyMHdoYWxlJTIwYnJlYWNoaW5nJTIwb2NlYW58ZW58MHx8fHwxNzg3ODE0MTkzfDA&ixlib=rb-4.1.0&q=85";

export const TEXTURE_NAVY =
  "https://static.prod-images.emergentagent.com/jobs/a7f34301-fa73-45c7-a983-497df7252520/images/19ba50f8732cb25dfb376148c6290b3c8a1c1ca64e5a5b125a1fe8379d27789b.jpeg";

export const GOLD_COAST_IMAGE =
  "https://customer-assets-jt897jd0.emergentagent.net/job_property-manager-425/artifacts/26zqjzec_image.png";

export const DESTINATIONS = [
  {
    id: "hervey-bay",
    eyebrow: "July – October · Hervey Bay",
    title: "Whale season in Hervey Bay",
    body:
      "Hervey Bay is where humpbacks stop to rest and play on the way south — thousands of them, in the calm water behind K'gari. Boats leave Urangan Marina, a four minute walk from Migaloo and Bahloo, and from Casa d' Mar's balcony at Kirra you can watch them pass without leaving your chair.",
    points: [
      "Whale watching boats from Urangan Marina",
      "Manta Ray ferry across to K'gari (Fraser Island)",
      "Marina, Boat Club, cinemas and cafés on foot",
    ],
    image: WHALE_IMAGE,
    imageAlt: "A humpback whale breaching off the Queensland coast",
    caption: "Humpback whale, Queensland coast — indicative regional image.",
    primary: { to: "/stay/paradisio", label: "See the Hervey Bay homes" },
    secondary: { to: "/enquire", label: "Ask about whale season dates" },
  },
  {
    id: "gold-coast",
    eyebrow: "Year round · Southern Gold Coast",
    title: "Surf and sunsets at Kirra",
    body:
      "Kirra is the wave the surfing world flies in for — the Superbank runs from Snapper Rocks past Kirra Point in long, fast walls, and Casa d' Mar sits absolute beachfront right on it. Duranbah, Greenmount and Coolangatta are all within a few minutes if the swell shifts.",
    points: [
      "Kirra Point, Snapper Rocks and the Superbank at your door",
      "Musgrave Street runs the length of the beachfront — café below the building, restaurants, bars and surf clubs up the street",
      "Coolangatta shops and markets close by, Gold Coast Airport minutes away",
    ],
    image: GOLD_COAST_IMAGE,
    imageAlt: "Kirra Beach at sunset from the air — the Superbank sand, Musgrave Street and the Coolangatta high rises",
    caption: "Kirra Beach and Musgrave Street at sunset, looking north to Coolangatta.",
    primary: { to: "/stay/casa-d-mar", label: "See Casa d' Mar" },
    secondary: { to: "/enquire", label: "Ask about Kirra dates" },
  },
];

export const LOCATIONS = [
  {
    name: "Kirra, Gold Coast",
    src: `${A}/wo65qgt3_IMG_6648.webp`,
    body:
      "The southern Gold Coast's most relaxed beachside pocket: world-famous surf, a café directly below the building, and restaurants, bars and surf clubs an easy stroll up the street.",
    slugs: ["casa-d-mar"],
  },
  {
    name: "Ramada Resort, Urangan",
    src: `${A}/ig8p5kiz_47ae0fe7-7a65-47ed-9148-9730e38968fa.webp`,
    body:
      "Two homes either side of the same wall at the Ramada, both with direct pool access and a four minute walk to Hervey Bay Marina.",
    slugs: ["migaloo", "bahloo"],
  },
  {
    name: "Oaks Urangan, Esplanade",
    src: `${A}/twz5zrio_02d799eb-70de-4835-a7bf-f3a6921de38d.webp`,
    body:
      "Down the road on the Esplanade: a premium ocean-view apartment with heated pools, a gym and a lift.",
    slugs: ["paradisio"],
  },
];
